import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { CodeSnippetService } from '@services/code-snippets/code-snippet.service';
import { MemoryService } from '@services/memory/memory.service';
import { DataTableComponent, DataTableEvent } from '../../../../components/data-table/data-table.component';
import moment from 'moment';

@Component({
    selector: 'app-composition-wizard-code-snippets',
    templateUrl: './composition-wizard-code-snippets.component.html',
    styleUrls: ['./composition-wizard-code-snippets.component.scss'],
    providers: [CodeSnippetService],
    standalone: false
})
export class CompositionWizardCodeSnippetsComponent implements OnInit {

  @Input() composition: Models.Composition;

  public columns = [
    { prop: 'title' },
    { prop: 'type' },
    {
      prop: 'updated', name: 'Last update', valueTransformer: function(date) {
        return moment(date).fromNow();
      }
    },
  ];

  public params = {
    type: 'json'
  };

  public assignedCodeSnippetsProvider: MemoryService<Models.CodeSnippet>;
  @ViewChild('assignedCodeSnippetsTable') assignedCodeSnippetsTable: DataTableComponent;
  private assignedCodeSnippets: Models.CodeSnippet[];

  constructor(public codeSnippetService: CodeSnippetService) {
  }

  ngOnInit() {
    this.assignedCodeSnippets = [];
    this.assignedCodeSnippetsProvider = new MemoryService(this.assignedCodeSnippets);

    if (this.composition.snippetIds && this.composition.snippetIds.length > 0) {
      this.codeSnippetService.find(0, 100, {
        _id: {
          $in: this.composition.snippetIds
        }
      }).then(response => {
        this.assignedCodeSnippets = response.data;
        this.updateAssignedCodeSnippets();
      });
    }
  }

  public assignImport(event: DataTableEvent): void {
    for (let i = 0; i < this.assignedCodeSnippets.length; i++) {
      if (this.assignedCodeSnippets[i]._id === event.row._id) {
        return;
      }
    }

    this.codeSnippetService.get(event.row._id).then(newImport => {
      this.assignedCodeSnippets.push(newImport);
      this.updateAssignedCodeSnippets();
    });
  }

  public removeAssignedCodeSnippet(event: DataTableEvent): void {
    this.assignedCodeSnippets.splice(event.index, 1);
    this.updateAssignedCodeSnippets();
  }

  private updateAssignedCodeSnippets(): void {
    const snippetIds: string[] = [];

    for (let i = 0; i < this.assignedCodeSnippets.length; i++) {
      snippetIds.push(this.assignedCodeSnippets[i]._id);
    }

    this.composition.snippetIds = snippetIds;

    this.assignedCodeSnippetsProvider.db = this.assignedCodeSnippets;
    this.assignedCodeSnippetsTable.refresh();
  }

}
